import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import counterReducer from "./counterReducer";
import { createStore } from "redux";
import { Provider } from "react-redux";

const store = createStore(counterReducer);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
